module.exports = __webpack_public_path__ + "static/img/create_import.5ee472a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/template/create_import.png
// module id = 5KCk
// module chunks = 0